import { Layout } from "./Layout";
import { LayoutHeader } from "./LayoutHeader";

Layout.Header = LayoutHeader;

export default Layout;
